import { render, staticRenderFns } from "./CompanyReport.vue?vue&type=template&id=271a8b60&scoped=true&"
import script from "./CompanyReport.vue?vue&type=script&lang=js&"
export * from "./CompanyReport.vue?vue&type=script&lang=js&"
import style0 from "./CompanyReport.vue?vue&type=style&index=0&id=271a8b60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a8b60",
  null
  
)

export default component.exports